

import React from "react";
import { compose } from "redux";
import { connect } from 'react-redux';
import { Popup, Loader, Dimmer } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import { Actions as KeyBuildsActions } from "../../../services/keyBuild/actions.jsx";
import { ReactComponent as BuildingIcon } from '../../../images/Building.svg';

class KeyBuildLoader extends React.Component {

    state = {
        loading: true,
        error: false
    };

    componentDidMount = () => {
        // Start fetching data
        this.props.fetchKeyBuildings(this.props.scenarioState.scenario.id);
    };

    componentDidUpdate(prevProps) {
        // Check fetching finished
        if (!this.props.keyBuildState.loading && prevProps.keyBuildState.loading) {
            if (this.props.keyBuildState.error) {
                // Error occurred - notify parent:
                this.props.fetchError("KeyBuild");
                this.setState({ loading: false, error: true });
            } else {
                this.props.fetchFinished("KeyBuild");
                this.setState({ loading: false, error: false });
            }
        }
    }

    render() {
        const { t } = this.props;
        var additionalClass = "";
        if (!this.state.loading) {
            if (!this.state.error) {
                additionalClass = " success";
            } else {
                additionalClass = " error";
            }
        }

        return (
            <div className="data-loader">
                <Popup
                    content={t("keyBuild.keyBuilds")}
                    position={"right center"}
                    size='mini'
                    trigger={
                        <div style={{ position: "relative" }}>
                            <Dimmer inverted active={this.state.loading}>
                                <Loader size='small' />
                            </Dimmer>
                            <BuildingIcon className={"data-loader-icon" + additionalClass} />
                        </div>
                    }
                />
            </div>
        );
    }
}

/*
* Maps state from the store to properties used by this class
*/
const mapStateToProps = (store, props) => {
    return {
        scenarioState: store.scenarioState,
        keyBuildState: store.keyBuildState,
        ...props
    }
}

/*
* Maps properties to dispatch methods to send actions to the store reducers
*/
const mapDispatchToProps = (dispatch) => {
    return {
        fetchKeyBuildings: (scenarioId) => {
            dispatch(KeyBuildsActions.fetchKeyBuildings(scenarioId));
        }
    }
}

export default compose(withTranslation(), connect(mapStateToProps, mapDispatchToProps))(KeyBuildLoader);